export { default } from './TypeformEmbed';
